import React from 'react';
import Button from './Button';

// The "nothing here yet" placeholder (icon + message + optional action) —
// every list page currently hand-writes its own version of this block, with
// small inconsistencies in icon size/color, copy tone, and border/spacing.
export default function EmptyState({ icon: Icon, title, subtitle, actionLabel, actionIcon, onAction }) {
  return (
    <div className="text-center py-16 bg-white rounded-2xl border border-dashed border-gray-200">
      {Icon && <Icon size={40} className="text-gray-300 mx-auto mb-3" />}
      <p className="text-gray-600 font-semibold">{title}</p>
      {subtitle && <p className="text-sm text-gray-400 mt-1 mb-5 max-w-sm mx-auto">{subtitle}</p>}
      {actionLabel && onAction && (
        <Button variant="primary" size="lg" icon={actionIcon} onClick={onAction} className="mx-auto">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
